import ProjectTableDenyAndEmptyPresentes from "./presenters";

const ProjectTableDenyAndEmpty = (props) => {
  return <ProjectTableDenyAndEmptyPresentes {...props} />;
};

export default ProjectTableDenyAndEmpty;
